import React from 'react';

import Img from '../../../Img';

import styles from './avatar.scss';

const Avatar = (props) => {
    const { profile } = props;
    const {
        firstName,
        lastName,
        profileImage,
    } = profile;

    return (
        <div className={`${styles.flexColumn} ${styles.avatar}`}>
            {profileImage ? (
                <Img
                    src={`/v1/player/${profileImage}`}
                />
            ) : (
                <div className={styles.initials}>{firstName?.[0]}{lastName?.[0]}</div>
            )}
        </div>
    );
};

export default Avatar;
